﻿<template>
    <div class="sm-head" v-if="getRef() != '0' && getRef() != null">
        <h5 class="sm-title">Trip summary</h5>
        <!-- the "Show / Hide breakdown" toggle is gone: every page shows the breakdown open (display_open), and its
             :hidden never applied (the button's display style overrode it), so it showed without doing anything -->
    </div>
    <!-- compact (cart): per tour its subtotal, dates, passengers grouped by price, accommodation, and its add-ons nested -->
    <div v-if="compact" class="sm-breakdown sm-compact" :hidden="display_details()">
        <section v-for="group in compact_groups()" :key="group.trip.tour_id" class="smc-trip">
            <div class="smc-head">
                <span class="smc-name">{{product_name(group.trip)}}</span>
                <strong class="smc-price">{{trip_total(group.trip)}}</strong>
            </div>
            <p class="smc-meta" v-if="compact_dates(group.trip) || durationInDays(group.trip)">
                <span v-if="compact_dates(group.trip)">{{compact_dates(group.trip)}}</span>
                <span v-if="isAAT()" v-html="product_duration(group.trip)"></span>
                <span v-else v-html="durationInDays(group.trip)"></span>
            </p>
            <ul class="smc-pax">
                <li v-for="(pax, index) in passenger_groups(group.trip)" :key="index">
                    <span class="smc-names">{{pax.label}} <small v-if="pax.each">{{pax.each}}</small></span>
                    <span class="smc-each">{{pax.total}}</span>
                </li>
            </ul>
            <p v-if="room_summary(group.trip)" class="smc-meta">Accommodation: {{room_summary(group.trip)}}</p>

            <div v-for="add_on in group.add_ons" :key="add_on.tour_id" class="smc-addon">
                <div class="smc-head">
                    <span class="smc-name"><span class="smc-plus" aria-hidden="true">+</span> {{product_name(add_on)}}</span>
                    <strong class="smc-price">{{trip_total(add_on)}}</strong>
                </div>
                <ul class="smc-pax">
                    <li v-for="(pax, index) in passenger_groups(add_on)" :key="index">
                        <span class="smc-names">{{pax.label}} <small v-if="pax.each">{{pax.each}}</small></span>
                        <span class="smc-each">{{pax.total}}</span>
                    </li>
                </ul>
            </div>
        </section>

        <div v-if="show_commission()" class="sm-row">
            <span>Nett</span>
            <span>{{ get_total_price_nett_formatted() }}</span>
        </div>
        <div v-if="show_commission()" class="sm-row">
            <span>Commission</span>
            <span>{{ get_total_price_commission_formatted() }}</span>
        </div>
        <div v-if="!hasAddOns()" class="sm-row is-total">
            <span>Total</span>
            <span>{{ get_total_price_formatted() }}</span>
        </div>
    </div>

    <div v-else class="sm-breakdown" :hidden="display_details()">
        <template v-for="trip in get_Trips()" :key="trip.tour_id">
            <div class="sm-trip" :hidden="!zeroPriceCheck(trip)">
                <div class="sm-row is-head">
                    <span>{{product_name(trip)}}</span>
                    <span v-if="isAAT()" v-html="product_duration(trip)"></span>
                    <span v-else v-html="durationInDays(trip)"></span>
                </div>

                <div class="sm-dates" :class="{ hidden: isAddon(trip) || product_check_dates(trip) }">
                    <template v-if="!isAAT()">
                        <span v-if="product_start_end_date(trip) != ''">{{product_start_end_date(trip)}}</span>
                        <template v-else>
                            <span>Start date: {{product_start_date(trip)}}</span>
                            <span>End date: {{product_end_date(trip)}}</span>
                        </template>
                    </template>
                    <template v-else-if="product_start_end_date(trip) == ''">
                        <span>Start date: {{product_start_date_Only(trip)}}</span>
                        <span>End date: {{product_end_date_only(trip)}}</span>
                    </template>
                </div>

                <div class="sm-row is-line" v-for="(passenger, index) in trip.passengers" :key="index">
                    <span>{{passenger_info(passenger)}}</span>
                    <span>{{passenger_price(passenger)}}</span>
                </div>

                <template v-if="room_breakdown(trip).length > 0">
                    <div class="sm-row is-head is-sub">
                        <span>Accommodation</span>
                        <span v-html="room_total(trip)"></span>
                    </div>
                    <div class="sm-row is-line" v-for="(room, index) in room_breakdown(trip)" :key="'room' + index">
                        <span>{{room.room_type}}</span>
                    </div>
                </template>
            </div>
        </template>

        <div v-if="show_commission()" class="sm-row">
            <span>Nett</span>
            <span>{{ get_total_price_nett_formatted() }}</span>
        </div>
        <div v-if="show_commission()" class="sm-row">
            <span>Commission</span>
            <span>{{ get_total_price_commission_formatted() }}</span>
        </div>
        <div v-if="!hasAddOns()" class="sm-row is-total">
            <span>Total</span>
            <span>{{ get_total_price_formatted() }}</span>
        </div>
    </div>

    <p v-if="getRef() != '0' && getRef() != null && display_open" class="sm-ref">Booking reference <strong>#{{ getRef() }}</strong></p>

</template>

<script lang="ts" src="./itinerary_breakdown.ts"></script>